import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Title = styled.div`
  ${theme.typography.titleSmall}
  font-size: 1.125rem;
  line-height: 1.5rem;
  color: ${theme.color.text.highlight};
  margin-bottom: 0.25rem;
`;

export const Description = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
`;

export const InfoLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;
